import {
  CollectionData,
  CollectionsLoaderState,
} from './collectionsLoaderState'

export const isSavedIn = (collection: CollectionData, componentId: number) =>
  collection.Components.find((component) => component.Id == componentId) !==
  undefined

export const isSaved = (
  collectionsLoaderState: CollectionsLoaderState,
  componentId: number
): boolean | 'unknown' => {
  if (
    collectionsLoaderState.kind === 'loaded' ||
    collectionsLoaderState.kind === 'loading'
  ) {
    const collectionsData = collectionsLoaderState.value
    if (collectionsData !== undefined)
      return (
        collectionsData
          .filter((collection) => isSavedIn(collection, componentId))
          .map((collection) => collection.Id).length > 0
      )
  }
  return 'unknown'
}
